// extracted by mini-css-extract-plugin
export default {"root":"dYhEso5A_6uxCXhva8fp","wrap":"mQs54ZARr4iwIAxyns9g","congrats":"Aow21mdahvwu6fdcanZo","earn":"PZfGxIyxDkusinPxBf_W","copy":"FTtmItfzcraBnbCfQm2z","btn":"uzpaMdQITTcCdhqlUew1"};